export default __webpack_public_path__ + "static/media/BF.2bc24179.svg";